
export const companyInfo = {
  name: "Carolina Trophy Roofs",
  url: "https://www.carolinatrophyroofs.com",
  logo: "https://www.carolinatrophyroofs.com/lovable-uploads/e80eb3a9-3d82-48e5-9bc0-8199657108ea.png", // Sitewide logo used in schema & Google favicon
  telephone: "(252) 302-2003",
  email: "Claims@CarolinaTrophyRoofs.com",
  address: {
    streetAddress: "136 S. Business Ct",
    addressLocality: "Rocky Mount",
    addressRegion: "NC",
    postalCode: "27804",
    addressCountry: "US"
  },
  greenvilleAddress: {
    streetAddress: "1414 Forbes St",
    addressLocality: "Greenville",
    addressRegion: "NC",
    postalCode: "27858",
    addressCountry: "US"
  },
  tarboroAddress: {
    streetAddress: "Tarboro, NC",
    addressLocality: "Tarboro",
    addressRegion: "NC",
    postalCode: "27886",
    addressCountry: "US"
  },
  sameAs: [
    "https://www.facebook.com/carolinatrophyroofs",
    "https://www.instagram.com/carolinatrophyroofs/?hl=en",
    "https://www.linkedin.com/company/81146474/admin/dashboard/",
    "https://www.youtube.com/channel/UC8pyyQN0WcMTbT-OHTQbhkA",
    "https://www.tiktok.com/@carolinatrophyroofs",
    "https://x.com/RoofsTrophy",
    "https://www.bbb.org/us/nc/rocky-mount/profile/roofing-contractors/carolina-trophy-roofs-llc-0593-90328252",
    "https://www.yelp.com/biz/carolina-trophy-roofs-rocky-mount",
    "https://www.trustpilot.com/review/carolinatrophyroofs.com",
    "https://www.angi.com/companylist/us/nc/rocky-mount/carolina-trophy-roofs-reviews-10015537.htm",
    "https://www.pinterest.com/carolinatrophyroofs/",
    "https://www.nationalroofingdirectory.org/united-states/rocky-mount/roofing-1/carolina-trophy-roofs",
    "https://www.thumbtack.com/nc/rocky-mount/roofing/carolina-trophy-roofs-votedbest-roofer-near-me/service/405902292554686466",
    "https://www.tripadvisor.com/Attraction_Review-g49487-d26260572-Reviews-Carolina_Trophy_Roofs-Rocky_Mount_North_Carolina.html",
    "https://www.mapquest.com/us/north-carolina/carolina-trophy-roofs-427666756",
    "https://linktr.ee/CarolinaTrophyRoofs"
  ],
  areaServed: "Rocky Mount, Greenville, Wilson, Tarboro, Zebulon, and Eastern North Carolina",
  awards: [
    "Top Roofing Contractor in Eastern NC - National Roofing Directory",
    "Best Roofer in Rocky Mount & Greenville - 2024"
  ],
  reviews: [
    {
      author: "Marcus Greene",
      rating: 5,
      reviewBody: "The best roofing team I've worked with. Professional and responsive."
    },
    {
      author: "Tamika Wells",
      rating: 5,
      reviewBody: "Carolina Trophy Roofs replaced our roof fast and affordably—highly recommended!"
    }
  ],
  contactPoints: [
    {
      telephone: "+1-252-302-2003",
      areaServed: "Rocky Mount",
      contactType: "customer service",
      availableLanguage: "English"
    },
    {
      telephone: "+1-252-371-2266",
      areaServed: "Greenville",
      contactType: "customer service",
      availableLanguage: "English"
    }
  ],
  locationGeo: {
    rockyMount: {
      latitude: 35.9382,
      longitude: -77.7905
    },
    greenville: {
      latitude: 35.6127,
      longitude: -77.3706
    },
    tarboro: {
      latitude: 35.9029,
      longitude: -77.535
    }
  }
};
